module.exports = __webpack_public_path__ + "img/jhPageShare.e7d23c1b.png";